// extracted by mini-css-extract-plugin
export default {"StepLayout":"SYn1r4EyJwhNAOKY_Kb9","OutroIcon":"PMMxzfAzVaKdKLuxUr_2"};